module.exports = __webpack_public_path__ + "img/collectCircle.a378a11a.png";